<script setup>
import { onMounted } from 'vue'
import router from '../router'
import { store } from '@/store/index.js'
import { getAuthProvider } from '@/oidc-config.js'

function consumeRedirectUrl() {
  const target = localStorage.getItem('redirectUrl')
  localStorage.removeItem('redirectUrl')
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/'
}

onMounted(async () => {
  try {
    await store.dispatch('oidc/oidcSignInCallback')
    const user =
  store.getters['oidc/oidcUser'] ??
  store.state.oidc?.user
const accessToken =
  store.getters['oidc/oidcAccessToken'] ??
  user?.access_token

    const provider = getAuthProvider(store.state.oidc?.user)

    // Keep the target for the Azure callback. Home starts Azure token acquisition
    // after the OIDC session has been restored for Scania users.
    const destination = provider === 'SCANIA' ? '/' : consumeRedirectUrl()
    await router.replace(destination)
  } catch (error) {
    console.error('OIDC callback failed:', error)
    await router.replace('/')
  }
})
</script>

<template>
  <div />
</template>
